import React from 'react';
import '../template-file-css/document-file-template.css';


export const LaGeneral_StrengthAndNeeds = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='LaGeneral_StrengthAndNeeds' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>MST Strengths & Needs Assessment</h3></center>
                </p>

                <p className='w-750'><center><h3>Individual</h3></center>
                </p>

                <p className='w-750'>{`Individual competencies and abilities (e.g., social skills and academic skills), attractiveness, intelligence, hobbies and interests, hygiene, motivation, and temperament.`}
                </p>

                <p className='w-750'> <span className='eleHeader'>Strengths (Protective Factors)</span>
                    <span className='small'>{`Identifies levers for change.Include more than 2 in each system`}</span>
                    <input type='text' id='txtStrengths_1' name='txtStrengths_1' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Needs (Risk Factors)</span>
                    <span className='small'>{`Identifies areas to target for change. Include more than 2 in each system`}</span>
                    <input type='text' id='txtNeeds_1' name='txtNeeds_1' className='add-only' />
                </p>

                <p className='w-750'><center><h3>Family</h3></center>
                </p>

                <p className='w-750'><b>Parent:</b>{`Social skills, concern, problem-solving ability, attractiveness, frustration tolerance, patience, altruism, and motivation.`}
                </p>

                <p className='w-750'><b>Family:</b>{`Financial resources (e.g., money, property, welfare benefits and employment income); basic needs are met (e.g., housing and food); child care is provided; transportation is available; strong affective and instrumental relations between spouses, parents and children; number and variety of social supports (e.g., extended family, friends, neighbors, coworkers, and church members); characteristics of the extended family; and recreational and leisure activities.`}
                </p>

                <p className='w-750'> <span className='eleHeader'>Strengths (Protective Factors)</span>
                    <span className='small'>{`Identifies levers for change.Include more than 2 in each system`}</span>
                    <input type='text' id='txtStrengths_2' name='txtStrengths_2' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Needs (Risk Factors)</span>
                    <span className='small'>{`Identifies areas to target for change. Include more than 2 in each system`}</span>
                    <input type='text' id='txtNeeds_2' name='txtNeeds_2' className='add-only' />
                </p>

                <p className='w-750'><center><h3>School</h3></center>
                </p>

                <p className='w-750'>{`Appropriate and effective classroom management practices and school-wide discipline procedures, concerned school personnel, teacher involvement in the community, prosocial after-school activities (e.g., drama, art, athletics, and interest clubs), cultural and community activities held at school, and efforts to engage families in their children's education.`}
                </p>

                <p className='w-750'> <span className='eleHeader'>Strengths (Protective Factors)</span>
                    <span className='small'>{`Identifies levers for change.Include more than 2 in each system`}</span>
                    <input type='text' id='txtStrengths_3' name='txtStrengths_3' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Needs (Risk Factors)</span>
                    <span className='small'>{`Identifies areas to target for change. Include more than 2 in each system`}</span>
                    <input type='text' id='txtNeeds_3' name='txtNeeds_3' className='add-only' />
                </p>

                <p className='w-750'><center><h3>Peers</h3></center>
                </p>

                <p className='w-750'>{`Individual competencies and abilities of peers; prosocial activities, hobbies, and interests; family monitoring and involvement in peer activities.`}
                </p>

                <p className='w-750'> <span className='eleHeader'>Strengths (Protective Factors)</span>
                    <span className='small'>{`Identifies levers for change.Include more than 2 in each system`}</span>
                    <input type='text' id='txtStrengths_4' name='txtStrengths_4' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Needs (Risk Factors)</span>
                    <span className='small'>{`Identifies areas to target for change. Include more than 2 in each system`}</span>
                    <input type='text' id='txtNeeds_4' name='txtNeeds_4' className='add-only' />
                </p>

                <p className='w-750'><center><h3>Community</h3></center>
                </p>

                <p className='w-750'>{`Recreational and leisure activities, voluntary associations (e.g., churches, neighborhood associations, sororities and fraternities, and the NAACP), law enforcement, business and industry, human services (e.g., economic assistance programs, housing and transportation support, child care, health care, and legal aid), and concerned and involved neighbors.`}
                </p>

                <p className='w-750'> <span className='eleHeader'>Strengths (Protective Factors)</span>
                    <span className='small'>{`Identifies levers for change.Include more than 2 in each system`}</span>
                    <input type='text' id='txtStrengths_5' name='txtStrengths_5' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Needs (Risk Factors)</span>
                    <span className='small'>{`Identifies areas to target for change. Include more than 2 in each system`}</span>
                    <input type='text' id='txtNeeds_5' name='txtNeeds_5' className='add-only' />
                </p>


            </div >
        </form >

    )
}